import React from "react";
import Login from "../components/login/Login";

const LoginContainer = ({ history }) => {
  return <Login />;
};

export default LoginContainer;
